import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'studentStatus',
  pure: true
})
export class StudentStatusPipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string | null | undefined): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('Status not set');
    }
    return this.lookupData.getStudentStatuses({
      selectedIds: [String(value)],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const status = result.items.find((s: { id: number | string }) => String(s.id) === String(value));
        const name = status ? ((status as { name?: string; nameEn?: string }).nameEn ?? status.name) : null;
        return name ?? 'Status not set';
      })
    );
  }
}
